/**
 * List-table dates for System Announcement — display as MM/DD/YYYY.
 * one "Start-End Date" column: `MM/DD/YYYY To MM/DD/YYYY`.
 */

function normalizeListDateYmd(value: string | number | undefined | null): string | null {
  if (value == null || value === '') return null

  const raw = String(value).trim()
  if (!raw) return null

  const iso = raw.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (iso) return `${iso[1]}-${iso[2]}-${iso[3]}`

  const slashYmd = raw.match(/^(\d{4})\/(\d{2})\/(\d{2})/)
  if (slashYmd) return `${slashYmd[1]}-${slashYmd[2]}-${slashYmd[3]}`

  const slashMdy = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/)
  if (slashMdy) {
    const m = slashMdy[1].padStart(2, '0')
    const d = slashMdy[2].padStart(2, '0')
    return `${slashMdy[3]}-${m}-${d}`
  }

  const mdy = raw.match(/^(\d{2})-(\d{2})-(\d{4})/)
  if (mdy) return `${mdy[3]}-${mdy[1]}-${mdy[2]}`

  const numeric = Number(raw)
  if (Number.isFinite(numeric) && numeric > 0) {
    const ms = numeric < 1e12 ? numeric * 1000 : numeric
    const date = new Date(ms)
    if (!Number.isNaN(date.getTime())) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, '0')
      const d = String(date.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    }
  }

  const parsed = new Date(raw)
  if (!Number.isNaN(parsed.getTime())) {
    const y = parsed.getFullYear()
    const m = String(parsed.getMonth() + 1).padStart(2, '0')
    const d = String(parsed.getDate()).padStart(2, '0')
    return `${y}-${m}-${d}`
  }

  return null
}

/** Display `YYYY-MM-DD` as `MM/DD/YYYY`. */
function ymdToDisplay(ymd: string): string {
  const match = ymd.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (!match) return ymd
  const [, y, m, d] = match
  return `${m}/${d}/${y}`
}

/** List cell: `MM/DD/YYYY To MM/DD/YYYY` */
export function formatSystemAnnouncementStartEndRange(
  startDate: string | number | undefined | null,
  endDate: string | number | undefined | null,
): string {
  const start = normalizeListDateYmd(startDate)
  const end = normalizeListDateYmd(endDate)

  if (start && end) return `${ymdToDisplay(start)} To ${ymdToDisplay(end)}`
  if (start) return ymdToDisplay(start)
  if (end) return ymdToDisplay(end)
  return '—'
}

export function formatSystemAnnouncementListDate(date: string | number | undefined | null): string {
  const d = normalizeListDateYmd(date)
  if (d) return ymdToDisplay(d)
  return '—'
}
